const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchCart ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-cart/search-cart', { params })
  },
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-cart/batch-create', params)
  },
  searchCartTbkItmes ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-cart/search-cart-tbk-itmes', { params })
  },
  batchDelete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/tpsp/v1frontend/tptt-cart/batch-delete', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
